module.exports = __webpack_public_path__ + "static/media/arrow-back-active.02948580.svg";